import $oauth2 from '@/libs/OAuth2/services/auth';

export default [
  /**
   * ROOT
   * la root del progetto non esiste
   * per questo si limita a smistare l'utente in base al ruolo nelle 2 macro sezioni
   * management e operative
   */
  {
    path: '/',
    name: 'root',
    meta: {
      auth: true,
    },
    beforeEnter: async (to, from, next) => {
      if (to.name !== 'root') {
        return next();
      }

      const me = await $oauth2.getMe();

      if (me.admin || me.consultant) {
        return next({
          name: 'management',
          replace: true,
        });
      }

      if (me.investor) {
        return next({
          name: 'investors',
          replace: true,
        });
      }

      return next({
        name: 'operative',
        replace: true,
      });
    },
  },

  /**
   * MANAGEMENT AREA
   * La sezione management gestisce le Aziende e i Supervisor
   * Accessibile soltanto da utenti di tipo admin e consultant (consultant con qualche limitazione)
   */
  {
    path: '/management',
    name: 'management',
    meta: {
      auth: true,
      user: false,
    },
    beforeEnter: async (to, from, next) => {
      if (to.name !== 'management') {
        return next();
      }

      const me = await $oauth2.getMe();

      if (me.admin || me.consultant) {
        return next({
          name: 'companies-index',
          replace: true,
        });
      }

      return next({
        name: 'investors-dashboard',
        replace: true,
      });
    },
    component: () => import(/* webpackChunkName: "consultants" */ '@/views/pages/Management/Root'),
    children: [
      /**
       * COMPANIES
       * La sezione Companies è accessibile sia da admin che consultant
       *
       * Le sottosezioni sono 2
       * indice delle aziende
       * show della singola azienda
       */
      {
        path: 'companies',
        name: 'companies',
        meta: {
          auth: true,
          user: false,
          investor: false,
        },
        redirect: {
          name: 'companies-index',
        },
        component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Company/Root'),
        children: [
          {
            path: '',
            name: 'companies-index',
            meta: {
              auth: true,
              user: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Company/Index'),
          },
          {
            path: 'new',
            name: 'companies-create',
            meta: {
              auth: true,
              user: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Company/Create'),
          },
          {
            path: ':id',
            name: 'companies-show',
            meta: {
              auth: true,
              user: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Company/Show'),
          },
          {
            path: ':id/edit',
            name: 'companies-edit',
            meta: {
              auth: true,
              user: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Company/Edit'),
          },
        ],
      },

      /**
       * CONSULTANTS
       * La sezione Consultants è accessibile solo dagli admin
       *
       * Le sottosezioni sono 2
       * indice dei consultant
       * show del singolo consultant
       */
      {
        path: 'consultants',
        name: 'consultants',
        meta: {
          auth: true,
          user: false,
          consultant: false,
          investor: false,
        },
        redirect: {
          name: 'consultants-index',
        },
        component: () => import(/* webpackChunkName: "consultants" */ '@/views/pages/Management/Consultant/Root'),
        children: [
          {
            path: '',
            name: 'consultants-index',
            meta: {
              auth: true,
              user: false,
              consultant: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "consultants" */ '@/views/pages/Management/Consultant/Index'),
          },
          {
            path: 'new',
            name: 'consultants-create',
            meta: {
              auth: true,
              user: false,
              consultant: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "consultants" */ '@/views/pages/Management/Consultant/Create'),
          },
        ],
      },

      /**
       * SETTINGS
       * La sezione Settings è accessibile solo dagli admin
       *
       */
      // {
      //   path: 'settings',
      //   name: 'settings',
      //   meta: {
      //     auth: true,
      //     user: false,
      //     consultant: false,
      //     investor: false,
      //   },
      //   component: () => import(/* webpackChunkName: "consultants" */ '@/views/pages/Management/Settings/Root'),
      // },

      /**
       * INVESTORS
       * La sezione Investors è accessibile solo dagli admin
       *
       * Le sottosezioni sono 2
       * indice degli investor
       * show del singolo investor
       */
      {
        path: 'investors',
        name: 'investors',
        meta: {
          auth: true,
          user: false,
          consultant: false,
          investor: false,
        },
        redirect: {
          name: 'investors-index',
        },
        component: () => import(/* webpackChunkName: "investors" */ '@/views/pages/Management/Investor/Root'),
        children: [
          {
            path: '',
            name: 'investors-index',
            meta: {
              auth: true,
              user: false,
              consultant: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "investors" */ '@/views/pages/Management/Investor/Index'),
          },
          {
            path: 'dashboard',
            name: 'investors-dashboard',
            meta: {
              auth: true,
              admin: false,
              user: false,
              consultant: false,
            },
            component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Management/Investor/Dashboard'),
          },
          {
            path: ':id',
            name: 'investors-show',
            meta: {
              auth: true,
              user: false,
              consultant: false,
              investor: false,
            },
            component: () => import(/* webpackChunkName: "investors" */ '@/views/pages/Management/Investor/Show'),
          },
        ],
      },

    ],
  },

  /**
   * OPERATIVE AREA
   * La sezione area operativa sta sotto il baseUrl /companies
   * Questa sezione è accessibile agli utenti user e consultant
   */
  {
    path: '/companies',
    meta: {
      auth: true,
    },
    component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Operative/Utilities/Root'),
    children: [
      /**
       * SELECT COMPANY
       * Serve a selezionare un contesto azienda
       * Se si ha soltanto un azienda fa redirect su operative-company
       */
      {
        path: '',
        name: 'operative',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "companies" */ '@/views/pages/Operative/Utilities/SelectCompany'),
        beforeEnter: async (to, from, next) => {
          if (to.name !== 'operative') {
            return next();
          }

          const me = await $oauth2.getMe();

          if (me.investor || me.roles?.includes('investor')) {
            return next();
          } else if ((me.companies?.length || 0) === 1) {
            return next({
              name: 'operative-company',
              params: {
                id: me.companies[0].id,
              },
              replace: true,
            });
          } else {
            return next();
          }
        },
      },

      /**
       * OPERATIVE COMPANY
       * il contensto aziendale sul quale vengono effettuate le operazioni
       * fa redirect su operative-company
       * Questa rotta e tutte le sottorotte effettuano un controllo
       * per accertarsi che si abbiano i permessi di gestione sull'azienda richiesta
       */
      {
        path: ':id',
        meta: {
          auth: true,
          withContext: true,
          layout: 'operative',
        },
        component: () => import(/* webpackChunkName: "operative" */ '@/views/pages/Operative/Frame'),
        children: [
          {
            path: '',
            name: 'operative-company',
            meta: {
              auth: true,
              withContext: true,
              layout: 'operative',
            },
            component: () => import(/* webpackChunkName: "operative" */ '@/views/pages/Operative/Dashboard/Dashboard'),
          },
          {
            path: 'dashboard',
            name: 'operative-company.dashboard.redirect',
            meta: {
              auth: true,
              withContext: true,
              layout: 'operative',
            },
            component: () => import(/* webpackChunkName: "operative" */ '@/views/pages/Operative/Dashboard/DashboardRedirect'),
          },
          {
            path: 'projects',
            component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
            children: [
              {
                path: 'dashboard',
                name: 'operative-company.projects.dashboard',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Dashboard'),
              },
              {
                path: 'library',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: 'imputedCosts',
                    component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                    children: [
                      {
                        path: '',
                        name: 'operative-company.projects.library.imputedCosts.list',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/ImputedCosts/List'),
                      },
                      {
                        path: 'new',
                        name: 'operative-company.projects.library.imputedCosts.add',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/ImputedCosts/New'),
                      },
                      {
                        path: ':imputedCostId/edit',
                        name: 'operative-company.projects.library.imputedCosts.edit',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/ImputedCosts/Edit'),
                      },
                    ],
                  },
                  {
                    path: 'expenses',
                    component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                    children: [
                      {
                        path: '',
                        name: 'operative-company.projects.library.expenses.list',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Expenses/List'),
                      },
                      {
                        path: 'new',
                        name: 'operative-company.projects.library.expenses.add',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Expenses/New'),
                      },
                      {
                        path: ':projectLibraryExpenseId/edit',
                        name: 'operative-company.projects.library.expenses.edit',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Expenses/Edit'),
                      },
                    ],
                  },
                  {
                    path: 'templates',
                    component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                    children: [
                      {
                        path: '',
                        name: 'operative-company.projects.library.templates.list',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Templates/List'),
                      },
                      {
                        path: 'new',
                        name: 'operative-company.projects.library.templates.add',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Templates/New'),
                      },
                      {
                        path: ':projectLibraryTemplateId/edit',
                        name: 'operative-company.projects.library.templates.edit',
                        meta: {
                          withContext: true,
                          layout: 'operative',
                        },
                        beforeEnter: ownedCompany,
                        component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Library/Templates/Edit'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'new',
                name: 'operative-company.projects.add',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/New'),
              },
              {
                path: '',
                name: 'operative-company.projects.list',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/List'),
              },
              {
                path: ':projectId/edit',
                name: 'operative-company.projects.edit',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Edit'),
              },
              {
                path: ':projectId',
                name: 'operative-company.projects.show',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "projects" */ '@/views/pages/Operative/Projects/Show'),
              },
            ],
          },
          {
            path: 'data-analysis',
            component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
            children: [
              {
                path: 'proceeds',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.proceeds',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "proceeds" */ '@/views/pages/Operative/DataAnalysis/Proceeds/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.proceeds.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "proceeds" */ '@/views/pages/Operative/DataAnalysis/Proceeds/New'),
                  },
                  {
                    path: ':proceedId/edit',
                    name: 'operative-company.data-analysis.proceeds.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "proceeds" */ '@/views/pages/Operative/DataAnalysis/Proceeds/Edit'),
                  },
                ],
              },
              {
                path: 'costiGA',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.ga',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "GA" */ '@/views/pages/Operative/DataAnalysis/CostsGa/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.ga.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "GA" */ '@/views/pages/Operative/DataAnalysis/CostsGa/New'),
                  },
                  {
                    path: ':costId/edit',
                    name: 'operative-company.data-analysis.ga.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "GA" */ '@/views/pages/Operative/DataAnalysis/CostsGa/Edit'),
                  },
                ],
              },
              {
                path: 'cogs',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.cogs',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "cogs" */ '@/views/pages/Operative/DataAnalysis/Cogs/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.cogs.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "cogs" */ '@/views/pages/Operative/DataAnalysis/Cogs/New'),
                  },
                  {
                    path: ':costId/edit',
                    name: 'operative-company.data-analysis.cogs.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "cogs" */ '@/views/pages/Operative/DataAnalysis/Cogs/Edit'),
                  },
                ],
              },
              {
                path: 'personnel',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.personnel',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "personnel" */ '@/views/pages/Operative/DataAnalysis/CostsPersonnel/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.personnel.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "personnel" */ '@/views/pages/Operative/DataAnalysis/CostsPersonnel/New'),
                  },
                  {
                    path: ':costId/edit',
                    name: 'operative-company.data-analysis.personnel.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "personnel" */ '@/views/pages/Operative/DataAnalysis/CostsPersonnel/Edit'),
                  },
                ],
              },
              {
                path: 'equity',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.equity',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "equities" */ '@/views/pages/Operative/DataAnalysis/Equities/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.equity.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "equities" */ '@/views/pages/Operative/DataAnalysis/Equities/New'),
                  },
                  {
                    path: ':equityId/edit',
                    name: 'operative-company.data-analysis.equity.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "equities" */ '@/views/pages/Operative/DataAnalysis/Equities/Edit'),
                  },
                ],
              },
              {
                path: 'contributi-fondo-perduto',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.contributi-fondo-perduto',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "contributi-fondo-perduto" */ '@/views/pages/Operative/DataAnalysis/ContributiFondoPerduto/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.contributi-fondo-perduto.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "contributi-fondo-perduto" */ '@/views/pages/Operative/DataAnalysis/ContributiFondoPerduto/New'),
                  },
                  {
                    path: ':contributoFondoPerdutoId/edit',
                    name: 'operative-company.data-analysis.contributi-fondo-perduto.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "contributi-fondo-perduto" */ '@/views/pages/Operative/DataAnalysis/ContributiFondoPerduto/Edit'),
                  },
                ],
              },
              {
                path: 'investimenti',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.investimenti',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "investimenti" */ '@/views/pages/Operative/DataAnalysis/Investimenti/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.investimenti.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "investimenti" */ '@/views/pages/Operative/DataAnalysis/Investimenti/New'),
                  },
                  {
                    path: ':investimentoId/edit',
                    name: 'operative-company.data-analysis.investimenti.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "investimenti" */ '@/views/pages/Operative/DataAnalysis/Investimenti/Edit'),
                  },
                ],
              },
              {
                path: 'finanziamenti',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.finanziamenti',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "finanziamenti" */ '@/views/pages/Operative/DataAnalysis/Finanziamenti/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.finanziamenti.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "finanziamenti" */ '@/views/pages/Operative/DataAnalysis/Finanziamenti/New'),
                  },
                  {
                    path: ':finanziamentoId/edit',
                    name: 'operative-company.data-analysis.finanziamenti.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "finanziamenti" */ '@/views/pages/Operative/DataAnalysis/Finanziamenti/Edit'),
                  },
                ],
              },
              {
                path: 'crediti-imposta',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.crediti-imposta',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "crediti-imposta" */ '@/views/pages/Operative/DataAnalysis/CreditiImposta/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.crediti-imposta.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "crediti-imposta" */ '@/views/pages/Operative/DataAnalysis/CreditiImposta/New'),
                  },
                  {
                    path: ':creditoImpostaId/edit',
                    name: 'operative-company.data-analysis.crediti-imposta.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "crediti-imposta" */ '@/views/pages/Operative/DataAnalysis/CreditiImposta/Edit'),
                  },
                ],
              },
              {
                path: 'scadenzari',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.scadenzari',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "scadenzari" */ '@/views/pages/Operative/DataAnalysis/Scadenzari/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.scadenzari.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "scadenzari" */ '@/views/pages/Operative/DataAnalysis/Scadenzari/New'),
                  },
                  {
                    path: ':crediti-imposta/edit',
                    name: 'operative-company.data-analysis.scadenzari.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "scadenzari" */ '@/views/pages/Operative/DataAnalysis/Scadenzari/Edit'),
                  },
                ],
              },
              {
                path: 'stati-patrimoniali',
                component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
                children: [
                  {
                    path: '',
                    name: 'operative-company.data-analysis.stati-patrimoniali',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "stati-patrimoniali" */ '@/views/pages/Operative/DataAnalysis/ConsuntivoStatiPatrimoniali/List'),
                  },
                  {
                    path: 'new',
                    name: 'operative-company.data-analysis.stati-patrimoniali.add',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "stati-patrimoniali" */ '@/views/pages/Operative/DataAnalysis/ConsuntivoStatiPatrimoniali/New'),
                  },
                  {
                    path: ':statoPatrimonialeId/edit',
                    name: 'operative-company.data-analysis.stati-patrimoniali.edit',
                    meta: {
                      withContext: true,
                      layout: 'operative',
                    },
                    beforeEnter: ownedCompany,
                    component: () => import(/* webpackChunkName: "stati-patrimoniali" */ '@/views/pages/Operative/DataAnalysis/ConsuntivoStatiPatrimoniali/Edit'),
                  },
                ],
              },
            ],
          },
          {
            path: 'fiscal-data',
            component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
            children: [
              {
                path: 'dinamica-iva',
                name: 'operative-company.fiscal-data.dinamica-iva',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "fiscal-data" */ '@/views/pages/Operative/FiscalData/DinamicaIva'),
              },
              {
                path: 'credito-imposta',
                name: 'operative-company.fiscal-data.credito-imposta',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "fiscal-data" */ '@/views/pages/Operative/FiscalData/CreditoImposta'),
              },
              {
                path: 'gestione-fiscale',
                name: 'operative-company.fiscal-data.gestione-fiscale',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "fiscal-data" */ '@/views/pages/Operative/FiscalData/GestioneFiscale'),
              },
            ],
          },
          {
            path: 'balance',
            component: () => import('@/views/pages/Operative/Utilities/InnerRouter'),
            children: [
              {
                path: '',
                name: 'operative-company.balance.balance',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "balance" */ '@/views/pages/Operative/Balance/Balance'),
              },
              {
                path: 'income-statement',
                name: 'operative-company.balance.income-statement',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "balance" */ '@/views/pages/Operative/Balance/IncomeStatement'),
              },
              {
                path: 'cash-flow',
                name: 'operative-company.balance.cash-flow',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "balance" */ '@/views/pages/Operative/Balance/CashFlow'),
              },
              {
                path: 'print',
                name: 'operative-company.balance.print',
                meta: {
                  withContext: true,
                  layout: 'operative',
                },
                beforeEnter: ownedCompany,
                component: () => import(/* webpackChunkName: "balance" */ '@/views/pages/Operative/Balance/Print'),
              },
            ],
          },
          {
            path: 'crisi-impresa',
            name: 'operative-company.crisi-impresa',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "kpi" */ '@/views/pages/Operative/CrisiImpresa/CrisiImpresa'),
          },
          {
            path: 'kpi',
            name: 'operative-company.kpi',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "kpi" */ '@/views/pages/Operative/Kpi/Kpi'),
          },
          {
            path: 'settings',
            name: 'operative-company.settings',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "settings" */ '@/views/pages/Operative/Settings/Settings'),
          },
          {
            path: 'users',
            name: 'operative-company.users',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "users" */ '@/views/pages/Operative/Users/Users'),
          },
          {
            path: 'investors',
            name: 'operative-company.investors',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "investors" */ '@/views/pages/Operative/Investors/Investors'),
          },
          {
            path: 'forecast',
            name: 'operative-company.forecast',
            meta: {
              withContext: true,
              layout: 'operative',
            },
            beforeEnter: ownedCompany,
            component: () => import(/* webpackChunkName: "forecasts" */ '@/views/pages/Operative/Forecast/Forecast'),
          },
        ],
      },
    ],
  },

  /**
   * ACCOUNT & LOGIN
   * Pagina di Login Utente
   * Pagina di Richiesta reset password
   * Pagina di Cambio Password dopo la conferma reset password tramite email
   * Pagina di Attivazione dell'utente registrato
   * */
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'modal',
      auth: false,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/pages/Public/Login'),
  },
  {
    path: '/password-reset/:email?',
    name: 'password-reset',
    meta: {
      layout: 'modal',
      auth: false,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/pages/Public/PasswordReset'),
  },
  {
    path: '/password-reset/:email/change-password/:token',
    name: 'password-reset-change-password',
    meta: {
      layout: 'modal',
      auth: false,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/pages/Public/ResetPasswordChange'),
  },
  {
    path: '/profile/:email/signup/:token',
    name: 'profile-signup',
    meta: {
      layout: 'modal',
    },
    component: () => import(/* webpackChunkName: "profile-signup" */ '@/views/pages/Public/Signup'),
  },

  /**
   * LOGOUT
   * Rotta di logout
   * Sprovvista di componente
   * effettua il redirect su login con successo o su root se fallimento
   * */
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: async (to, from, next) => {
      try {
        if (!await $oauth2.getMe()) {
          throw new Error('User not logged in');
        }
        await $oauth2.logout();
      } catch (error) {}

      next({ name: 'root', replace: true });
    },
  },

  /** CATCHALL **/
  {
    path: '*',
    redirect: { name: 'root' },
  },
];

async function ownedCompany (to, from, next) {
  const me = await $oauth2.getMe();
  const { id } = to.params;

  if (!me) {
    return next({ name: 'login' });
  }
  if (me.investor || me.admin) {
    return next();
  }

  const company = (me.companies || []).find(company => company.id === id);
  if (company) {
    return next();
  }

  next({ name: 'operative' });
}
